/*@flow*/
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { set } from 'ops';
import { Fragment } from 'react';
import SignInForm from 'comps/SignIn';
import useStoreState from 'lib/useStoreState';
import PasswordResetForm from 'comps/PasswordReset';
import cx from 'classnames';

const forms = {
  SignIn: SignInForm,
  PasswordReset: PasswordResetForm,
};
const titles = {
  SignIn: 'Sign in',
  PasswordReset: 'Reset your password',
};

const path1 = 'mode.gatewayModal.type';
const mapPath = {
  gatewayMode: path1,
};

const btnMsgs = {
  SignIn: 'Sign in',
};

function Link({ type }: { type: string }) {
  const { gatewayMode } = useStoreState(mapPath);
  // Hide SignIn link when the value of gatewayMode is blank. This
  // tells us that we are currently looking at the SignIn view already.
  if (type === 'SignIn' && !gatewayMode) return null;
  if (type === gatewayMode) return null;
  const testid = `${type}Link`;

  return (
    <button
      data-testid={testid}
      style={{
        fontSize: '1.4rem',
        borderWidth: 1,
      }}
      onClick={() => set(path1, type)}
      className={cx(
        'btn btn-block btn-sm mb-3 p-2 btn-outline-info text-info bg-white'
      )}
      tabIndex={10}
    >
      {btnMsgs[type]}
    </button>
  );
}

const LinksView = () => <Link type="SignIn" />;

const Component = () => {
  const { gatewayMode } = useStoreState(mapPath);
  const FormView = forms[gatewayMode] || forms.SignIn;
  const title = titles[gatewayMode] || 'Sign in';

  return (
    <div
      css={css(`
      display: grid;
      align-items: center;
      justify-items: center;
      height: 100%;
      font-size: 1.4rem;

      .btn-primary {
        font-size: 1.4rem;
      }

      form {
        margin: 0;
        position: relative;
      }

      .form-wrapper {
        margin: 20px auto 20px;

        @media (min-width: 468px) {
          width: 300px;
        }
      }

      button[type='submit'] {
        margin-top: 10px;
      }

      .form-group {
        position: relative;
      }

      .has-error .error-block {
        position: absolute;
        top: 10px;
        font-size: 1.2rem;
        left: -160px;
        width: 150px;
        max-height: 65px;
        text-align: right;
        background: #f10000;
        color: white !important;
        padding: 3px 10px;
      }
    `)}
    >
      <div>
        <h2
          data-testid="GatewayTitle"
          css={css(`
          margin-top: 0;
          margin-bottom: 0;
          font-size: 2.3em;
          text-align: center;
        `)}
        >
          {title}
        </h2>
        <div className="flex-center">
          <div className="form-wrapper">
            <FormView />
            <LinksView />
          </div>
        </div>
      </div>
    </div>
  );
};

export default (Component: any);
